module.exports = __webpack_public_path__ + "static/media/minus-white-16-16.c7cb14b6.svg";